import React from 'react';

import PropTypes from 'prop-types';

import { formatGrade } from '@client/utils/grade-levels';

import { $card } from './style';
import ExpandableText from '../ExpandableText';

const getSafeListString = (listData, mapFunc) => {
  if (!Array.isArray(listData)) return '';

  return listData.map(mapFunc).join(', ');
};

const getCrossWalkData = (crosswalk) => {
  return {
    id: crosswalk.id,
    grades: getSafeListString(crosswalk.grade_levels, (grade) => formatGrade(String(grade.numeric_representation))),
    subject: getSafeListString(crosswalk.subjects, (subject) => subject.name),
    year: crosswalk.adoption_year || '',
    name: crosswalk.name,
    description: crosswalk.description,
    regions: getSafeListString(crosswalk.regions, (region) => region.abbreviation),
  };
};

const CrosswalkCard = ({ crosswalk }) => {
  const { regions, subject, year, grades, name, description } = getCrossWalkData(crosswalk);

  return (
    <div css={$card}>
      <div>
        [{regions}] [{year}] [{subject}] [{grades}]
      </div>
      <ExpandableText title={name} text={description} />
    </div>
  );
};

CrosswalkCard.propTypes = {
  crosswalk: PropTypes.object.isRequired,
};

export default CrosswalkCard;
